<template>
  <div id="loading-indication" v-show="show">
    <b-progress
      height=".5rem"
      class="mb-2"
      :value="100"
      variant="info"
      animated
      label="loading"
    ></b-progress>
    <!--
    <b-spinner variant="danger" label="Spinning"/>
    -->
    <span>{{ status }}</span>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["status"]),
    show() {
      return !(this.status == "" || this.status == "success" || this.status == "error")
    }
  },
};
</script>
